// extracted by mini-css-extract-plugin
module.exports = {"columnItem":"addressDetailsForm_columnItem__J5RY8"};